import { NameForm } from "./components/NameForm";
import { Footer } from "./components/Footer";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import "./index.css";

export function App() {
  return (
    <div className="app">

      <Container>
        <Row className="mt-4">
          <div className="mt-4">&nbsp;</div>
        </Row>
        <Row>
          <Col sm={2}></Col>
          <Col>
            <h1>Warriors Name Generator</h1>
            <NameForm />
          </Col>
          <Col sm={2}></Col>
        </Row>
        <Row className="mt-4">
          <div className="mt-4">&nbsp;</div>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default App;
